module.exports = __webpack_public_path__ + "media/images/features/support/eyecatch-type-01-e11d4d5428986b2d8f995c54bc6662e4.svg";